var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.3016H4V5.4595C4 3.89255 5.346 2.61739 7 2.61739C8.654 2.61739 10 3.89255 10 5.4595V6.40687H12V5.4595C12 2.8476 9.757 0.722656 7 0.722656C4.243 0.722656 2 2.8476 2 5.4595V8.3016C0.897 8.3016 0 9.15234 0 10.1963V16.8279C0 17.8729 0.897 18.7227 2 18.7227H12C13.103 18.7227 14 17.8729 14 16.8279V10.1963C14 9.15139 13.103 8.3016 12 8.3016ZM2 16.8279V10.1963H12L12.001 16.8279H2Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lockIcon.753347dae7e5ad7161f491468813b416.svg";
export { ForwardRef as ReactComponent };